import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'Dialog' })
export default class Dialog extends Vue {
  @Prop({ default: false })
  private visible: boolean | undefined;

  private handleCancel() {
    this.$emit('cancel');
  }

  private handleConfirm() {
    this.$emit('confirm');
  }

  private handleClose() {
    this.$emit('close');
  }

  private render() {
    return (
      <div class={style.dialogContainer} v-show={this.visible}>
        <div class={style.layer}>
          <div class={style.box}>
            <span class={style.icon} onClick={this.handleClose.bind(this)} />
            <div class={style.title}>是否保存修改</div>
            <div class={style.btnGroup}>
              <div class={style.cancel} onClick={this.handleCancel.bind(this)}>放弃</div>
              <div class={style.confirm} onClick={this.handleConfirm.bind(this)}>保存</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
